/*
 ** ECN内容
 */
export const ECN_CONTENT_LIST = [
  {
    ECNName: '人员变更',
    ECNCheckArr: [
      { name: '特殊工位', Flag: 0 },
      { name: '持上岗证人员', Flag: 0 },
      { name: '经认可人员', Flag: 0 },
      { name: '其他', Flag: 0 }
    ],
    beforeText: '',
    afterText: '',
    description: ''
  },
  {
    ECNName: '设备变更',
    ECNCheckArr: [
      { name: '生产用设备', Flag: 0 },
      { name: '测量用设备', Flag: 0 },
      { name: '客户指定设备', Flag: 0 },
      { name: '模具（含关键组件）', Flag: 0 },
      { name: '其他', Flag: 0 }
    ],
    beforeText: '',
    afterText: '',
    description: ''
  },
  {
    ECNName: '材料变更',
    ECNCheckArr: [
      { name: '直接材料', Flag: 0 },
      { name: '间接材料', Flag: 0 },
      { name: '客户指定材料或品牌', Flag: 0 },
      { name: '其他', Flag: 0 }
    ],
    beforeText: '',
    afterText: '',
    description: ''
  },
  {
    ECNName: '方法变更',
    ECNCheckArr: [
      { name: '工艺', Flag: 0 },
      { name: '工序', Flag: 0 },
      { name: '检测方法', Flag: 0 },
      { name: '其他', Flag: 0 }
    ],
    beforeText: '',
    afterText: '',
    description: ''
  },
  {
    ECNName: '检测变更',
    ECNCheckArr: [
      { name: '检验标准', Flag: 0 },
      { name: '其他', Flag: 0 }
    ],
    beforeText: '',
    afterText: '',
    description: ''
  },
  {
    ECNName: '环境变更',
    ECNCheckArr: [
      { name: '生产线变更', Flag: 0 },
      { name: '工厂迁址', Flag: 0 },
      { name: '委外加工', Flag: 0 },
      { name: '其他', Flag: 0 }
    ],
    beforeText: '',
    afterText: '',
    description: ''
  },
  {
    ECNName: '材料停产',
    ECNCheckArr: [
      { name: '停产', Flag: 0 },
      { name: '其他', Flag: 0 }
    ],
    beforeText: '',
    afterText: '',
    description: ''
  }
];
